import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { getIcons } from "../Constant/Constant";

const CustomTable = ({
  columns = [],
  data = [],
  isPagination = false,
  pageSize = 10,
  currentPage = 1,
  nextId = null,
  prevId = null,
  hasMore = false,
  loading = false,
  onPageChange = () => {},
  onPageSizeChange = () => {},
  imageNotFound = getIcons().teamEmpty ,
}) => {
  const handlePageSizeChange = (e) => {
    const newPageSize = parseInt(e.target.value, 10);
    onPageSizeChange(newPageSize);
  };

  return (
    <div className="overflow-x-auto bg-white shadow-lg rounded-[10px] px-5 py-4">
      <table className="min-w-full border-collapse text-sm font-medium text-gray-900">
        <thead className="text-[15px] text-center text-gray-700 bg-[#F9F9F9]">
          <tr className="border-b border-gray-300">
            {columns.map((col, index) => (
              <th
                key={col.key}
                scope="col"
                className={`px-6 py-4 text-center 
                  ${index === 0 ? "rounded-s-lg" : ""} 
                  ${index === columns.length - 1 ? "rounded-e-lg" : ""}`}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="px-6 py-4 text-center text-gray-500 rounded-b-lg"
              >
                {loading ? (
                  <div className="flex justify-center items-center h-full">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
                  </div>
                ) : (
                  <div className="flex justify-center items-center h-full">
                    <div className="flex flex-col items-center gap-2">
                    <div className="text-customGreen font-medium text-lg">No data available</div>
                    <img src={imageNotFound} alt="Not Found" className=" w-[80%] ml-4" />
                    </div>
                    
                </div>
                )}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={row.id || rowIndex}
                className="hover:bg-slate-50 transition-colors duration-150 border-b border-gray-200"
              >
                {columns.map((col, colIndex) => (
                  <td
                    key={col.key}
                    className={`px-6 py-4 text-center text-gray-700 
                      ${
                        rowIndex === data.length - 1 && colIndex === 0
                          ? "rounded-bl-lg"
                          : ""
                      }
                      ${
                        rowIndex === data.length - 1 &&
                        colIndex === columns.length - 1
                          ? "rounded-br-lg"
                          : ""
                      }`}
                  >
                    {col.render
                      ? col.render(row[col.key], row)
                      : row[col.key] ?? "-"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {isPagination && (
        <div className="flex items-center justify-between border-t pt-2 px-3">
          <div className="text-sm text-gray-500">
            <select
              className="border rounded-[10px] input-focus p-2"
              onChange={handlePageSizeChange}
              value={pageSize}
            >
              <option value="10">1 - 10</option>
              <option value="50">1 - 50</option>
              <option value="100">1 - 100</option>
            </select>
          </div>

          <div className="flex justify-center my-3 gap-1">
            {currentPage > 1 && (
              <button
                onClick={() => onPageChange(prevId, "previous")}
                className="mx-1 p-2 min-w-[40px] min-h-[40px] border rounded-[10px] border-customGreen cursor-pointer"
                aria-label="Go to previous page"
                disabled={loading}
              >
                <MdKeyboardArrowRight className="text-customGreen text-2xl transform rotate-180 transition-transform duration-300" />
              </button>
            )}

            <div className="bg-customGreen shadow-lg mx-1 p-2 min-w-[40px] min-h-[40px] border border-customGreen text-center text-white rounded-[10px]">
              {currentPage}
            </div>

            <button
              onClick={() => onPageChange(nextId, "next")}
              className={`mx-1 p-2 min-w-[40px] min-h-[40px] border border-customGreen rounded-[10px] transition duration-300 ${
                hasMore && !loading ? "cursor-pointer" : "cursor-not-allowed text-gray-400"
              }`}
              aria-label="Go to next page"
              disabled={!hasMore || loading}
            >
              <MdKeyboardArrowRight className="text-customGreen text-2xl" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomTable;